<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
       fill="currentColor"
       :class="`icon-${ icon }`"
       :aria-label="ariaLabel"
       :role="decorative ? 'presentation' : null"
       :aria-hidden="decorative"
       :focusable="!decorative"
  >
    <use :xlink:href="`#icon-${ icon }`" />
  </svg>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent( {
  name: 'Icon',
  props: {
    icon: {
      type: String,
      required: true,
      default: 'info'
    },
    ariaLabel: {
      type: String,
      default: '',
      required: false,
    }
  },
  setup( props ) {
    const decorative = computed( () => ! props.ariaLabel );

    return {
      decorative,
      ariaLabel: props.ariaLabel || undefined
    };
  }
} );
</script>
